import React from 'react';
import isEmpty from 'lodash/isEmpty';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilters,
  FetchProductsSort
} from '../../../../../../products/productsTypes';

import {
  CACHE_FETCH_SHOW_PRODUCT_IMAGE_QUERY,
  CacheFetchShowProductImageQueryResponse
} from '../../../../../../products/queries/fetchCacheShowProductImage.query';
import {
  FETCH_SHOW_PRODUCT_IMAGE_QUERY,
  FetchShowProductImageQueryResponse
} from '../../../../../../products/queries/fetchShowProductImage.query';

import { useThreeDStockProductsSearch } from '../../../../../pages/ThreeDStockProducts/hooks/useThreeDStockProductsSearch';
import { useCacheProduct } from '../../../../../../products/hooks/useCacheProduct';
import { useShowToastOnErrorChange } from '../../../../../../../common/hooks/useShowToastOnErrorChange';

import {
  FileAttachmentItemImageVersions,
  ImageHelper
} from '../../../../../../../helpers/ImageHelper';
import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

import { words } from '../../../../../../../locales/keys';

import { ProductCache } from '../../../../../../products/ProductCache';

interface ThreeDStockProductsFiltersProductFilterBadgeProps {
  productsFilters: FetchProductsFilters;
  changeProductsFilters: ChangeProductsFiltersFunc;
  sortProducts?: (nextSort: FetchProductsSort) => void;
}

function ThreeDStockProductsFiltersProductFilterBadge({
  productsFilters,
  changeProductsFilters,
  sortProducts
}: ThreeDStockProductsFiltersProductFilterBadgeProps) {
  const productNanoId = productsFilters?.similarProduct?.productId;

  const { product, productError } = useCacheProduct<
    CacheFetchShowProductImageQueryResponse | FetchShowProductImageQueryResponse
  >({
    cacheKey: ProductCache.showImageCacheKey(),
    cacheQuery: CACHE_FETCH_SHOW_PRODUCT_IMAGE_QUERY,
    productNanoId,
    query: FETCH_SHOW_PRODUCT_IMAGE_QUERY,
    options: {
      enabled: !!productNanoId,
      enabledPlaceholder: false
    }
  });

  useShowToastOnErrorChange({
    error: productError
  });

  const { onClearSearchSimilarImage } = useThreeDStockProductsSearch({
    changeProductsFilters,
    sortProducts,
    isLibrary: !isEmpty(productsFilters.clientIds)
  });

  if (!product) {
    return null;
  }

  return (
    <div className="p-4">
      <div className="relative">
        <ImageHelper
          className="w-full h-auto rounded-lg shadow-sm"
          src={product.image?.file}
          alt="imageSearch"
          version={FileAttachmentItemImageVersions.MiniThumb640x640}
          tooltipAlt
          tooltipAltInteractive
          tooltipAltAppendToBody
        />

        <div className="absolute bottom-0 right-0 p-2">
          <PureButtonHelper
            dataGa="clear-search-similar-image-button"
            className="py-1 pl-2 pr-2 rounded-full inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 focus:ring-base text-gray-900 bg-white hover:bg-gray-100 shadow-sm hover:shadow-md transition-colors duration-150 ease-out"
            onClick={onClearSearchSimilarImage}
            i18nText={words.clear}
          />
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockProductsFiltersProductFilterBadge;
